export default __webpack_public_path__ + "static/media/loginSvgAprobank.2a261e1a.svg";